import { Component, Type, Injectable, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Overlay } from 'angular2-modal';
import { Modal } from 'angular2-modal/plugins/bootstrap';

@Injectable()
export class ModalService {

    private viewContainerRef: ViewContainerRef;

    constructor(
        private overlay: Overlay,
        private modal: Modal
    ) {
    }

    public setViewContainerRef(viewContainerRef: any) {
        this.viewContainerRef = viewContainerRef;
        this.overlay.defaultViewContainer = this.viewContainerRef;
    }

    public confirm(title: string, message: string): Observable<any> {
        return Observable.fromPromise(this.modal.confirm()
            .size('lg')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .title(title)
            .body(message)
            .open()
            .catch(err => { throw new Error(err); }) // catch error not related to the result (modal open...)
            .then(dialog => dialog.result) // dialog has more properties,lets just return the promise for a result.
            .then(result => {
                return result;
            }) // if were here ok was clicked.
            .catch(err => { throw new Error(err); })
        );
    }

    public confirmCustom(component: Type<Component>, data: any): Observable<any> {
        return Observable.of({});
    }

    public info(title: string, message: string): Observable<any> {
        return Observable.fromPromise(this.modal.alert()
            .size('lg')
            .isBlocking(false)
            .showClose(true)
            .keyboard(27)
            .title(title)
            .body(message)
            .open()
            .catch(err => { throw new Error(err); }) // catch error not related to the result (modal open...)
            .then(dialog => dialog.result) // dialog has more properties,lets just return the promise for a result.
            .then(result => {
                return result;
            }) // if were here ok was clicked.
            .catch(err => { throw new Error(err); })
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/modal.service.ts